import { render, staticRenderFns } from "./reserveOrder.vue?vue&type=template&id=131328a5&"
import script from "./reserveOrder.vue?vue&type=script&lang=js&"
export * from "./reserveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports